module.exports = __webpack_public_path__ + "static/media/logo.f21f7c41.png";